
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/industries/education/products/plagiarism-detection-and-academic-integrity-software",
      function () {
        return require("private-next-pages/industries/education/products/plagiarism-detection-and-academic-integrity-software.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/industries/education/products/plagiarism-detection-and-academic-integrity-software"])
      });
    }
  